import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"

class MatrizCurricular extends Component {


 
  state = {
    nome:null,
    nsemestre:null,
    duracaohoras:null,
    error:null,
    success:null,
    matrizcurricular:[],
    idcurso:this.props.match.params.idcurso,
    idtodel:null,
    idtoedit:null
  }

  async loadmatriz(){
    const {idcurso}= this.state;
    const response = await api.post("/disciplinas/curso", { idcurso});
    this.setState({
      matrizcurricular:response.data
    })

  }

  componentDidMount(){
    this.loadmatriz();
  }


  adddiscplina = async e => {
    e.preventDefault();
    console.log(this.state);
    const { nome,nsemestre,duracaohoras,idcurso } = this.state;
      if (!nome || !nsemestre || !duracaohoras || !idcurso) {
          this.setState({ error: "Preencha os dados antes de adicionar!",
        success:null });
          
      } else {
      const { nome,nsemestre,duracaohoras, idcurso } = this.state;
      const response = await api.post("/admin/disciplina/add", { idcurso,nome,nsemestre,duracaohoras });

        if(response.data.id){
          this.setState({ success: "Matriz Cadastrado!" , error:null,
         });
         this.loadmatriz();
        }

      }
  }




  async removerdisciplina(id) {
    console.log(id);

      const response = await api.post("/admin/disciplina/del", { iddisciplina:id });

        if(response.data.deleted_at){
          this.setState({ success: "Matriz Deletada!" , error:null,
         });
         this.loadmatriz();
        }
  
  }

  

  async shouldComponentUpdate(nextProps, nextState){

    if(nextState.idtodel!==this.state.idtodel){
      this.removerdisciplina(nextState.idtodel);
    }

    if(nextState.idtoedit!==this.state.idtoedit){
      this.props.history.push("/admin/cursos/matrizcurricular/"+nextState.idcurso+"/"+nextState.idtoedit+"");
    }
    return true;
  }


  

  render() {
    return (
      <React.Fragment>

<Header />
        <div class="container col-sm-6 p-4">     

       


        <div class="container">
  <div class="row">
    <div class="col-sm">



    <h4>Nova Disciplina</h4>     
        <form onSubmit={this.adddiscplina} class="col">

        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
                <div class="form-group">
                    <label for="exampleFormControlInput1">Ordem</label>
                    <input type="number" class="form-control" onChange={e => this.setState({ nsemestre: e.target.value })} placeholder="Digite o nome da nova Categoria" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" onChange={e => this.setState({ nome: e.target.value })} placeholder="Digite o nome" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Duração</label>
                    <input type="number" class="form-control" onChange={e => this.setState({ duracaohoras: e.target.value })} placeholder="Digite quantidade de horas" />
                </div>
                <div class="form-group">
                <button class="btn btn-primary mb-2">Adicionar</button>

                </div>
        </form>


  

    </div>




    <div class="col-sm">
   

    </div>
  </div>
</div>










    {/* Tables */}

    <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
  <thead>
    <tr>
      <th class="th-sm">Nome

      </th>
      <th class="th-sm">Duração

      </th>
      <th class="th-sm">Ação

      </th>
    </tr>
  </thead>
  <tbody>
  {this.state.matrizcurricular.map(el => (
    <tr>
    <td>{el.nome}</td>
    <td>{el.duracaohoras} horas</td>
    <td>
    <a class="btn btn-primary btn-sm" onClick={e => this.setState({ idtoedit: el.id} )}>Editar</a>
      <a class="btn btn-danger btn-sm" onClick={e => this.setState({ idtodel: el.id} )}>Remover</a>
    </td>
  </tr>
  ))}
    

   
  </tbody>

</table>

{/* FIm table */}


    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(MatrizCurricular);


// WEBPACK FOOTER //
// ./src/pages/Admin/matrizcurricular.js